const snack = require('../../../../../components/snack/snack')

export function start(detail) {

  snackBody[detail.id].start(detail)

  detail.html = snackBody[detail.id]
  snack.start(detail)

}

const snackBody = {

  emailResult: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"snack", "act":"hide"}
          ]}'`,

    start: function (detail) {
      this.title = detail.text
    }
  },

  noDecimal: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"snack", "act":"hide"}
          ]}'`,


    start: function () {
      this.title = 'Decimal amounts are not accepted in this field'        //language.start('inProgress')     
      // this.btn     = 'Undo'        //language.start('inProgress')     

    }
  },

  restriction: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"snack", "act":"hide"}
          ]}'`,


    start: function () {
      this.title = 'You cannot delete this item'        //language.start('inProgress')     
      // this.btn     = 'Undo'        //language.start('inProgress')     

    }
  },

  insufficientQuantity: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"snack", "act":"hide"}
          ]}'`,


    start: function () {
      this.title = 'Insufficient quantity in inventory for Lost'        //language.start('inProgress')     
      // this.btn     = 'Undo'        //language.start('inProgress')     

    }
  },

  insufficientPrice: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"snack", "act":"hide"}
          ]}'`,


    start: function (detail) {
      this.title = 'Insufficient total returned in inventory for Lost: $' + parseFloat(detail.total_price).toFixed(2) +
        '. Spent credit is $' + parseFloat(detail.spendCredit).toFixed(2);        //language.start('inProgress')     
      // this.btn     = 'Undo'        //language.start('inProgress')     

    }
  },

  ItemLostNotExistIn_purchaseVsItem: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"snack", "act":"hide"}
          ]}'`,


    start: function (detail) {
      this.title = 'This item lost not exist in Items: ' + detail.item_name

      // this.btn     = 'Undo'        //language.start('inProgress')     

    }
  },

  purchaseTotalLessThanPayment: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"snack", "act":"hide"}
          ]}'`,


    start: function (detail) {
      this.title = 'The total purchase is less than the payment received: ' + detail.sent_amount

      // this.btn     = 'Undo'        //language.start('inProgress')     

    }
  },

  NotExistCOGS: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"snack", "act":"hide"}
          ]}'`,


    start: function (detail) {
      this.title = 'There is a COGS deleted that has payment. Please reload the page.'

      // this.btn     = 'Undo'        //language.start('inProgress')     

    }
  },

  cogsAmountLessThanPayment: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"snack", "act":"hide"}
          ]}'`,


    start: function (detail) {
      this.title = 'The amount COGS is less than the payment received: ' + detail.sent_amount

      // this.btn     = 'Undo'        //language.start('inProgress')     

    }
  },

  dataIA: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"snack", "act":"hide"}
          ]}'`,


    start: function (detail) {
      this.title = detail.text
    }
  },

  errorServer: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"snack", "act":"hide"}
          ]}'`,


    start: function (detail) {
      this.title = detail.text
    }
  },

  errorProvider: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"snack", "act":"hide"}
          ]}'`,


    start: function (detail) {
      this.title = detail.text
    }
  }

}





